var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-card full-width q-px-sm q-pb-md" },
    [
      _c(
        "div",
        { staticClass: "row gutter-xs" },
        [
          _vm.renderPresentialEventCatalogCode()
            ? _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-input",
                    {
                      ref: "presential_event_catalog_code",
                      attrs: {
                        "float-label": _vm.$t("course_catalog_code"),
                        filter: "",
                        "autofocus-filter": "",
                        clearable: "",
                        error: _vm.$v.presential_event_catalog_code.$error
                      },
                      on: {
                        clear: _vm.removeCatalogCode,
                        input: _vm.$v.presential_event_catalog_code.$touch
                      },
                      model: {
                        value: _vm.presential_event_catalog_code,
                        callback: function($$v) {
                          _vm.presential_event_catalog_code = $$v
                        },
                        expression: "presential_event_catalog_code"
                      }
                    },
                    [
                      _c("q-autocomplete", {
                        attrs: {
                          debounce: 500,
                          "min-characters": 1,
                          "max-results": 100,
                          "value-field": function(v) {
                            return "" + v.code
                          }
                        },
                        on: {
                          search: _vm.fetchCatalogCodes,
                          selected: _vm.selectCatalogCode
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-field",
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("requester"),
                      disable: "",
                      readonly: ""
                    },
                    model: {
                      value: _vm.user_requester_name_email,
                      callback: function($$v) {
                        _vm.user_requester_name_email = $$v
                      },
                      expression: "user_requester_name_email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-field",
                { attrs: { count: 256 } },
                [
                  _c("q-input", {
                    ref: "title",
                    attrs: {
                      "float-label": _vm.$t("title"),
                      error: _vm.$v.title.$error,
                      disable:
                        _vm.disableBasicData ||
                        !_vm.permissions.presential_edit_basic_data
                    },
                    on: { input: _vm.$v.title.$touch },
                    model: {
                      value: _vm.title,
                      callback: function($$v) {
                        _vm.title = $$v
                      },
                      expression: "title"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("span", { staticClass: "caption q-mb-sm block" }, [
                _vm._v(_vm._s(_vm.$t("introduction")))
              ]),
              _c(
                "q-field",
                { attrs: { count: 1024 } },
                [
                  _c("q-input", {
                    staticStyle: { display: "none" },
                    model: {
                      value: _vm.descriptionWithoutHTML,
                      callback: function($$v) {
                        _vm.descriptionWithoutHTML = $$v
                      },
                      expression: "descriptionWithoutHTML"
                    }
                  }),
                  _c(
                    "q-editor",
                    {
                      attrs: {
                        "content-style": _vm.contentStyleDescription,
                        disable:
                          _vm.disableBasicData ||
                          !_vm.permissions.presential_edit_basic_data,
                        toolbar: [
                          ["bold", "italic", "strike", "underline"],
                          ["left", "center", "right", "justify"],
                          ["link", "upload"],
                          [
                            {
                              label: null,
                              icon: "fas fa-font",
                              fixedLabel: true,
                              fixedIcon: true,
                              list: "no-icons",
                              options: [
                                "p",
                                "h1",
                                "h2",
                                "h3",
                                "h4",
                                "h5",
                                "h6",
                                "code"
                              ]
                            },
                            {
                              label: null,
                              icon: "fas fa-text-height",
                              fixedLabel: true,
                              fixedIcon: true,
                              list: "no-icons",
                              options: [
                                "size-1",
                                "size-2",
                                "size-3",
                                "size-4",
                                "size-5",
                                "size-6",
                                "size-7"
                              ]
                            },
                            "removeFormat"
                          ],
                          ["quote", "unordered", "ordered"],
                          ["custom_btn"]
                        ],
                        definitions: {
                          bold: { label: null, icon: "fas fa-bold" },
                          italic: { label: null, icon: "fas fa-italic" },
                          strike: { label: null, icon: "fas fa-strikethrough" },
                          underline: { label: null, icon: "fas fa-underline" },
                          left: { label: null, icon: "fas fa-align-left" },
                          center: { label: null, icon: "fas fa-align-center" },
                          right: { label: null, icon: "fas fa-align-right" },
                          justify: {
                            label: null,
                            icon: "fas fa-align-justify"
                          },
                          link: { label: null, icon: "fas fa-link" },
                          upload: {
                            tip: null,
                            icon: "fas fa-file-image",
                            handler: _vm.insertImg
                          },
                          removeFormat: { label: null, icon: "fas fa-eraser" },
                          quote: { label: null, icon: "fas fa-quote-right" },
                          unordered: { label: null, icon: "fas fa-list-ul" },
                          ordered: { label: null, icon: "fas fa-list-ol" }
                        }
                      },
                      on: { input: _vm.$v.descriptionWithoutHTML.$touch },
                      model: {
                        value: _vm.description,
                        callback: function($$v) {
                          _vm.description = $$v
                        },
                        expression: "description"
                      }
                    },
                    [
                      _c("q-btn", {
                        attrs: {
                          slot: "custom_btn",
                          dense: "",
                          flat: "",
                          color: "black",
                          icon: "fal fa-code",
                          label: "HTML"
                        },
                        on: {
                          click: function($event) {
                            _vm.show_description_html = true
                          }
                        },
                        slot: "custom_btn"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.current_client !== "universidadechevrolet" &&
          _vm.current_client === "academiacoral"
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        warning: _vm.hasTrainingCode,
                        helper:
                          "" +
                          (_vm.trainings_code.length > 1
                            ? _vm.$t("there_are_trainings_that_use_this_code")
                            : _vm.$t("presential_code_helper_message"))
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          loading: _vm.loading_code,
                          type: "text",
                          "float-label": _vm.$t("training_code"),
                          disable:
                            _vm.disableBasicData ||
                            !_vm.permissions.presential_edit_basic_data
                        },
                        on: { blur: _vm.searchCode },
                        model: {
                          value: _vm.code,
                          callback: function($$v) {
                            _vm.code = $$v
                          },
                          expression: "code"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasTrainingCode
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c("q-btn", {
                    attrs: {
                      color: "secondary",
                      size: "small",
                      label: _vm.$t("trainings")
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("q-select", {
                ref: "appointment_type_id",
                attrs: {
                  options: _vm.appointment_types,
                  "float-label": _vm.$t("appointment_type"),
                  error: _vm.$v.appointment_type_id.$error,
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                on: { input: _vm.updateParticipantsAndValidate },
                model: {
                  value: _vm.appointment_type_id,
                  callback: function($$v) {
                    _vm.appointment_type_id = $$v
                  },
                  expression: "appointment_type_id"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-4" },
            [
              _c("q-input", {
                attrs: {
                  value: _vm.minimumParticipants,
                  "float-label": _vm.$t("minimum_participants"),
                  disable: ""
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-4" },
            [
              _c("q-input", {
                attrs: {
                  value: _vm.maximumParticipants,
                  "float-label": _vm.$t("maximum_participants"),
                  disable: ""
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-4" },
            [
              _c("q-input", {
                attrs: {
                  value: _vm.individualValue,
                  "float-label": _vm.$t("individual_value"),
                  prefix: "$",
                  disable: ""
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-chips-input",
                {
                  ref: "instructors_labels",
                  attrs: {
                    "float-label": _vm.$t("instructor"),
                    debounce: 600,
                    clearable: "",
                    error: _vm.$v.instructors.$error,
                    disable:
                      _vm.disableBasicData ||
                      !_vm.permissions.presential_edit_basic_data
                  },
                  on: {
                    remove: _vm.removeInstructor,
                    input: _vm.$v.instructors.$touch
                  },
                  model: {
                    value: _vm.instructors_labels,
                    callback: function($$v) {
                      _vm.instructors_labels = $$v
                    },
                    expression: "instructors_labels"
                  }
                },
                [
                  _c("q-autocomplete", {
                    attrs: {
                      "min-characters": 3,
                      "max-results": 30,
                      "value-field": function(v) {
                        return "" + v.label
                      }
                    },
                    on: {
                      search: _vm.searchInstructor,
                      selected: _vm.selectInstructor
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-input",
                {
                  ref: "company_branch",
                  attrs: {
                    "float-label": _vm.$t("location_name"),
                    autocomplete: "new-password",
                    debounce: 600,
                    clearable: "",
                    error: _vm.$v.company_branch.$error,
                    disable:
                      _vm.disableBasicData ||
                      !_vm.permissions.presential_edit_basic_data
                  },
                  on: {
                    clear: _vm.removeBranch,
                    input: _vm.$v.company_branch.$touch
                  },
                  model: {
                    value: _vm.company_branch_name,
                    callback: function($$v) {
                      _vm.company_branch_name = $$v
                    },
                    expression: "company_branch_name"
                  }
                },
                [
                  _c("q-autocomplete", {
                    attrs: {
                      "min-characters": 3,
                      "max-results": 50,
                      "value-field": function(e) {
                        return (
                          e.name +
                          " " +
                          (e.fantasy ? " / " + e.fantasy : "") +
                          " " +
                          (e.document ? e.document : "") +
                          " / " +
                          e.address.address +
                          (e.address.number ? ", " + e.address.number : "") +
                          " - " +
                          e.address.city +
                          "/" +
                          e.address.state
                        )
                      },
                      separator: ""
                    },
                    on: { search: _vm.searchBranch, selected: _vm.selectBranch }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("q-input", {
                attrs: { "float-label": _vm.$t("address"), disable: "" },
                model: {
                  value: _vm.company_branch_address,
                  callback: function($$v) {
                    _vm.company_branch_address = $$v
                  },
                  expression: "company_branch_address"
                }
              })
            ],
            1
          ),
          _vm.current_client === "academiacoral"
            ? _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-input",
                    {
                      attrs: {
                        "float-label": _vm.$t("partner_branch"),
                        autocomplete: "new-password",
                        debounce: 600,
                        clearable: "",
                        disable:
                          _vm.disableBasicData ||
                          !_vm.permissions.presential_edit_basic_data
                      },
                      on: { clear: _vm.removePartner },
                      model: {
                        value: _vm.partner_name,
                        callback: function($$v) {
                          _vm.partner_name = $$v
                        },
                        expression: "partner_name"
                      }
                    },
                    [
                      _c("q-autocomplete", {
                        attrs: {
                          "min-characters": 3,
                          "max-results": 50,
                          "value-field": function(e) {
                            return (
                              e.name +
                              " " +
                              (e.fantasy ? " / " + e.fantasy : "") +
                              " " +
                              (e.document ? e.document : "") +
                              " / " +
                              e.address.address +
                              (e.address.number
                                ? ", " + e.address.number
                                : "") +
                              " - " +
                              e.address.city +
                              "/" +
                              e.address.state
                            )
                          },
                          separator: ""
                        },
                        on: {
                          search: _vm.searchPartner,
                          selected: _vm.selectPartner
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("q-select", {
                attrs: {
                  options: _vm.timezones,
                  "float-label": _vm.$t("timezone"),
                  filter: "",
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                on: {
                  input: function($event) {
                    return _vm.changeTimezone()
                  }
                },
                model: {
                  value: _vm.timezone,
                  callback: function($$v) {
                    _vm.timezone = $$v
                  },
                  expression: "timezone"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 q-mt-md" },
            [
              _c("p", { staticClass: "caption q-mb-xs" }, [
                _vm._v(_vm._s(_vm.$t("categories_modules")))
              ]),
              _c("q-checkbox", {
                staticClass: "q-mb-xs",
                attrs: {
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data,
                  val: true,
                  label: _vm.$t("select_all_categories_modules")
                },
                on: {
                  input: function($event) {
                    return _vm.checkAllCategories()
                  }
                },
                model: {
                  value: _vm.all_product_categories,
                  callback: function($$v) {
                    _vm.all_product_categories = $$v
                  },
                  expression: "all_product_categories"
                }
              }),
              _c("q-select", {
                ref: "product_categories",
                attrs: {
                  options: _vm.product_categories_list.map(function(e) {
                    return { value: e.value, label: e.title }
                  }),
                  multiple: "",
                  chips: "",
                  filter: "",
                  error: _vm.$v.product_categories.$error,
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                on: { input: _vm.changeProducts },
                model: {
                  value: _vm.product_categories,
                  callback: function($$v) {
                    _vm.product_categories = $$v
                  },
                  expression: "product_categories"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 q-mt-md" },
            [
              _c("p", { staticClass: "caption q-mb-xs" }, [
                _vm._v(_vm._s(_vm.$t("products_themes")))
              ]),
              _c("q-checkbox", {
                staticClass: "q-mb-xs",
                attrs: {
                  disable:
                    _vm.product_categories.length < 1 ||
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data,
                  val: true,
                  label: _vm.$t("select_all_product_themes")
                },
                on: {
                  input: function($event) {
                    return _vm.checkAllProducts()
                  }
                },
                model: {
                  value: _vm.all_products,
                  callback: function($$v) {
                    _vm.all_products = $$v
                  },
                  expression: "all_products"
                }
              }),
              _c("q-select", {
                ref: "products",
                attrs: {
                  options: _vm.filteredProducts,
                  multiple: "",
                  chips: "",
                  filter: "",
                  error: _vm.$v.products.$error,
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                on: { input: _vm.$v.products.$touch },
                model: {
                  value: _vm.products,
                  callback: function($$v) {
                    _vm.products = $$v
                  },
                  expression: "products"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12" },
            [
              _c("q-input", {
                ref: "qty_expected_participants",
                attrs: {
                  type: "number",
                  "float-label": _vm.$t("expected_participants"),
                  error: _vm.$v.qty_expected_participants.$error,
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                on: { input: _vm.$v.qty_expected_participants.$touch },
                model: {
                  value: _vm.qty_expected_participants,
                  callback: function($$v) {
                    _vm.qty_expected_participants = $$v
                  },
                  expression: "qty_expected_participants"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("q-input", {
                attrs: {
                  type: "number",
                  "float-label": _vm.$t("score"),
                  error: _vm.$v.score.$error,
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                on: { input: _vm.$v.score.$touch },
                model: {
                  value: _vm.score,
                  callback: function($$v) {
                    _vm.score = $$v
                  },
                  expression: "score"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("q-input", {
                ref: "workload",
                attrs: {
                  type: "number",
                  "float-label": _vm.$t("workload_in_hours"),
                  error: _vm.$v.workload.$error,
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                on: { input: _vm.$v.workload.$touch },
                model: {
                  value: _vm.workload,
                  callback: function($$v) {
                    _vm.workload = $$v
                  },
                  expression: "workload"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12" },
            [
              _c("q-select", {
                attrs: {
                  options: _vm.optionTags,
                  "float-label": _vm.$t("tags"),
                  multiple: "",
                  chips: "",
                  filter: "",
                  "autofocus-filter": "",
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                model: {
                  value: _vm.tags,
                  callback: function($$v) {
                    _vm.tags = $$v
                  },
                  expression: "tags"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              class:
                _vm.current_client === "academiacoral"
                  ? "col-xs-5 col-sm-5"
                  : "col-xs-6 col-sm-6"
            },
            [
              _c("q-select", {
                attrs: {
                  error: !_vm.presential_event_type ? true : false,
                  options: _vm.presential_event_types.map(function(e) {
                    return { label: _vm.$t(e.slug), value: e.value }
                  }),
                  "float-label": _vm.$t("training_type"),
                  disable:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data
                },
                model: {
                  value: _vm.presential_event_type,
                  callback: function($$v) {
                    _vm.presential_event_type = $$v
                  },
                  expression: "presential_event_type"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { padding: "10px 2px" } },
            [
              _c(
                "q-icon",
                {
                  staticClass: "q-mr-sm q-pt-md",
                  attrs: {
                    name: "fal fa-question-circle",
                    size: "1.5rem",
                    color: "grey"
                  }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      staticClass: "custom-tooltip",
                      attrs: { anchor: "top left", self: "bottom right" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.getEventTypeTooltip(_vm.presential_event_type)
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.current_client === "academiacoral"
            ? _c(
                "div",
                { staticClass: "col-xs-5 col-sm-5" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.listed_training_types,
                      "float-label": _vm.$t("training_listing"),
                      disable:
                        _vm.disableBasicData ||
                        !_vm.permissions.presential_edit_basic_data
                    },
                    model: {
                      value: _vm.is_listed,
                      callback: function($$v) {
                        _vm.is_listed = $$v
                      },
                      expression: "is_listed"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.current_client === "academiacoral"
            ? _c(
                "div",
                { staticStyle: { padding: "10px 2px" } },
                [
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-mr-sm q-pt-md",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("training_listing_type_tooltip")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.selected_client_params
            .use_presential_events_certificate_expiration
            ? _c("inputExpireCertificate", {
                ref: "inputExpireCertificate",
                attrs: {
                  disableInput:
                    _vm.disableBasicData ||
                    !_vm.permissions.presential_edit_basic_data,
                  qty_days: _vm.qty_days
                },
                on: { fnInDays: _vm.fnInDays }
              })
            : _vm._e(),
          _c("div", { staticClass: "col-12 q-mb-md" }, [
            _c("div", { staticClass: "row gutter-sm" }, [
              _vm.id != 0 && _vm.isBoticario
                ? _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("certificate")))
                      ]),
                      _c("uploader", {
                        attrs: {
                          content_type: "images",
                          multiple: false,
                          filename: "certificate",
                          id: _vm.id,
                          custom_certificate_module_path: "presential_event",
                          disable:
                            _vm.disableBasicData ||
                            !_vm.permissions.presential_edit_basic_data
                        },
                        on: { fileUploaded: _vm.certificateImageUploaded }
                      }),
                      _vm.certificate_image_url
                        ? _c(
                            "p",
                            { staticClass: "q-mt-md file-url" },
                            [
                              _c("q-icon", {
                                attrs: {
                                  name: "fal fa-check",
                                  color: "positive"
                                }
                              }),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.certificate_image_url,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$truncateLink(
                                          _vm.certificate_image_url
                                        )
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6 q-mt-xs" },
                [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("image")))
                  ]),
                  _c("uploader", {
                    attrs: {
                      content_type: "images",
                      multiple: false,
                      cropper: true,
                      aspect_ratio: 52 / 29,
                      aspect_ratio_string: "52/29",
                      disable:
                        _vm.disableBasicData ||
                        !_vm.permissions.presential_edit_basic_data
                    },
                    on: { fileUploaded: _vm.imageUploaded }
                  }),
                  _vm.image_url_presential_event
                    ? _c(
                        "p",
                        { staticClass: "q-mt-md file-url" },
                        [
                          _c("q-icon", {
                            attrs: { name: "fal fa-check", color: "positive" }
                          }),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.image_url_presential_event,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$truncateLink(
                                      _vm.image_url_presential_event
                                    )
                                  )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                _c(
                  "p",
                  { staticClass: "caption" },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("alt_image")) +
                        "\n\t\t\t\t\t\t"
                    ),
                    _c(
                      "q-icon",
                      {
                        staticClass: "q-ml-sm q-pb-sm",
                        attrs: {
                          name: "fal fa-question-circle",
                          size: "1.5rem",
                          color: "grey"
                        }
                      },
                      [
                        _c(
                          "q-tooltip",
                          {
                            staticClass: "custom-tooltip",
                            attrs: { anchor: "top left", self: "bottom right" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("alt_image_information_helper")) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex justify-between" },
                  [
                    _vm._l(_vm.languages, function(lang) {
                      return [
                        lang.code === "pt-br"
                          ? _c(
                              "q-field",
                              { key: lang.id, attrs: { count: 170 } },
                              [
                                _c("q-input", {
                                  ref: "language_br",
                                  refInFor: true,
                                  attrs: {
                                    "float-label": _vm.$t("" + lang.name),
                                    error: _vm.$v.language_br.$error
                                  },
                                  on: { input: _vm.$v.language_br.$touch },
                                  model: {
                                    value: _vm.language_br,
                                    callback: function($$v) {
                                      _vm.language_br = $$v
                                    },
                                    expression: "language_br"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        lang.code === "en-us"
                          ? _c(
                              "q-field",
                              { key: lang.id, attrs: { count: 170 } },
                              [
                                _c("q-input", {
                                  ref: "language_us",
                                  refInFor: true,
                                  attrs: {
                                    "float-label": _vm.$t("" + lang.name),
                                    error: _vm.$v.language_us.$error
                                  },
                                  on: { input: _vm.$v.language_us.$touch },
                                  model: {
                                    value: _vm.language_us,
                                    callback: function($$v) {
                                      _vm.language_us = $$v
                                    },
                                    expression: "language_us"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        lang.code === "es-es"
                          ? _c(
                              "q-field",
                              { key: lang.id, attrs: { count: 170 } },
                              [
                                _c("q-input", {
                                  ref: "language_es",
                                  refInFor: true,
                                  attrs: {
                                    "float-label": _vm.$t("" + lang.name),
                                    error: _vm.$v.language_es.$error
                                  },
                                  on: { input: _vm.$v.language_es.$touch },
                                  model: {
                                    value: _vm.language_es,
                                    callback: function($$v) {
                                      _vm.language_es = $$v
                                    },
                                    expression: "language_es"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        lang.code === "fr-fr"
                          ? _c(
                              "q-field",
                              { key: lang.id, attrs: { count: 170 } },
                              [
                                _c("q-input", {
                                  ref: "language_fr",
                                  refInFor: true,
                                  attrs: {
                                    "float-label": _vm.$t("" + lang.name),
                                    error: _vm.$v.language_fr.$error
                                  },
                                  on: { input: _vm.$v.language_fr.$touch },
                                  model: {
                                    value: _vm.language_fr,
                                    callback: function($$v) {
                                      _vm.language_fr = $$v
                                    },
                                    expression: "language_fr"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 q-mt-md",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab_permission,
            callback: function($$v) {
              _vm.tab_permission = $$v
            },
            expression: "tab_permission"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-user-check",
              label: _vm.$t("target_audience")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: {
                        disable:
                          _vm.disableBasicData ||
                          !_vm.permissions.presential_edit_basic_data,
                        val: true,
                        label: _vm.$t("select_all_areas")
                      },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("select-multiple", {
                      attrs: {
                        label: "",
                        filters: _vm.area,
                        options: _vm.areas,
                        error: _vm.$v.area.$error,
                        input: _vm.$v.area.$touch,
                        disable:
                          _vm.disableBasicData ||
                          !_vm.permissions.presential_edit_basic_data
                      },
                      on: {
                        on_value: function($event) {
                          _vm.area = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disable:
                                _vm.disableBasicData ||
                                !_vm.permissions.presential_edit_basic_data
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              ref: "profile",
                              refInFor: true,
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error),
                                disable:
                                  _vm.disableBasicData ||
                                  !_vm.permissions.presential_edit_basic_data
                              },
                              on: { input: _vm.$v.profile.$touch },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      ref: "user_group",
                      attrs: {
                        filter: "",
                        "autofocus-filter": "",
                        options: _vm.user_groups,
                        "float-label": _vm.$t("user_groups"),
                        error: _vm.$v.user_group.$error,
                        multiple: "",
                        chips: "",
                        disable:
                          _vm.disableBasicData ||
                          !_vm.permissions.presential_edit_basic_data
                      },
                      on: { input: _vm.$v.user_group.$touch },
                      model: {
                        value: _vm.user_group,
                        callback: function($$v) {
                          _vm.user_group = $$v
                        },
                        expression: "user_group"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c(
                    "q-chips-input",
                    {
                      ref: "companies_label",
                      attrs: {
                        "float-label": _vm.$t("headquarters"),
                        debounce: 600,
                        clearable: "",
                        error: _vm.$v.company.$error,
                        disable:
                          _vm.disableBasicData ||
                          !_vm.permissions.presential_edit_basic_data
                      },
                      on: {
                        remove: _vm.removeHeadquarter,
                        input: _vm.$v.company.$touch
                      },
                      model: {
                        value: _vm.companies_label,
                        callback: function($$v) {
                          _vm.companies_label = $$v
                        },
                        expression: "companies_label"
                      }
                    },
                    [
                      _c("q-autocomplete", {
                        attrs: { "min-characters": 1, "max-results": 100 },
                        on: {
                          search: _vm.fetchHeadquarters,
                          selected: _vm.selectHeadquarter
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      ref: "branch",
                      attrs: {
                        filter: "",
                        "autofocus-filter": "",
                        options: _vm.branches,
                        "float-label": _vm.$t("branches"),
                        error: _vm.$v.branch.$error,
                        multiple: "",
                        chips: "",
                        readonly: _vm.disableBasicData,
                        disable:
                          _vm.company.length > 0
                            ? false
                            : true ||
                              _vm.disableBasicData ||
                              !_vm.permissions.presential_edit_basic_data
                      },
                      on: {
                        input: function($event) {
                          _vm.current_client === "universidadechevrolet"
                            ? _vm.addVacancies(_vm.branch)
                            : null
                        }
                      },
                      model: {
                        value: _vm.branch,
                        callback: function($$v) {
                          _vm.branch = $$v
                        },
                        expression: "branch"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm.current_client === "universidadechevrolet" &&
              _vm.branch.length > 0
                ? _c("div", { staticClass: "q-mt-md col-xs-12 col-sm-12" }, [
                    _c("p", { staticClass: "caption q-mt-lg" }, [
                      _vm._v(_vm._s(_vm.$t("vacancy_division")))
                    ]),
                    _c(
                      "div",
                      { staticClass: "row gutter-sm q-pb-sm" },
                      _vm._l(_vm.vacancies, function(item, index) {
                        return _c(
                          "div",
                          { key: "va" + index, staticClass: "col-xs-12" },
                          [
                            _c("q-input", {
                              staticClass: "custom-input",
                              attrs: {
                                outlined: "",
                                type: "number",
                                prefix: item.label + ": "
                              },
                              on: { blur: _vm.checkVacancies },
                              model: {
                                value: item.qty_vacancies,
                                callback: function($$v) {
                                  _vm.$set(item, "qty_vacancies", $$v)
                                },
                                expression: "item.qty_vacancies"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm.id != 0 && _vm.status !== 9
                ? _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-11" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("link"),
                            disable: true
                          },
                          model: {
                            value: _vm.url_presential_training,
                            callback: function($$v) {
                              _vm.url_presential_training = $$v
                            },
                            expression: "url_presential_training"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-1 q-mt-lg" },
                      [
                        _c(
                          "q-btn",
                          {
                            staticClass: "full-width",
                            attrs: {
                              dense: "",
                              color: "primary",
                              icon: "fal fa-copy"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyLink()
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("copy_link")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _vm.showSaveAsModel
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("cancel")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("save_as_model"),
                    icon: "fal fa-file-user"
                  },
                  on: {
                    click: function($event) {
                      _vm.save_as_model_dialog = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.showSaveBasicData
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label:
                      _vm.status === 9 ? _vm.$t("save_model") : _vm.$t("save"),
                    icon: "far fa-save"
                  },
                  on: {
                    click: function($event) {
                      return _vm.saveData()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            hide: function($event) {
              _vm.show_modal = false
            }
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("trainings")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.trainings_code,
                      columns: _vm.columns,
                      "row-key": "index"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                {
                                  key: "title",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.title) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.save_as_model_dialog = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("save") },
                    on: {
                      click: function($event) {
                        return _vm.saveAsModel()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.save_as_model_dialog,
            callback: function($$v) {
              _vm.save_as_model_dialog = $$v
            },
            expression: "save_as_model_dialog"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("save_as_model")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("do_you_confirm_saving_as_model")))
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_description_html,
            callback: function($$v) {
              _vm.show_description_html = $$v
            },
            expression: "show_description_html"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_description_html = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [_vm._v("\n\t\t\t\t\tHTML\n\t\t\t\t")])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "10",
                          "float-label": "HTML"
                        },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_description_html = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }